import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export function useLenis() {
  useEffect(() => {
    if (lenisInstance) return;

    // Respect reduced motion
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    lenisInstance = new Lenis({
      duration: prefersReduced ? 0.0 : 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: !prefersReduced,
      smoothTouch: false,
      lerp: 0.09,
    });

    let rafId;
    function raf(time) {
      if (lenisInstance) lenisInstance.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      if (lenisInstance) {
        lenisInstance.destroy();
        lenisInstance = null;
      }
    };
  }, []);
}

export function getLenis() {
  return lenisInstance;
}
